import * as types from '../actionTypes/customersActionsType';
import * as clientTypes from '../actionTypes/clientsActionsType';
const initialState = {
    customers: [],
    total: 0,
    loading: false,
    loaded: false,
    selectedCustomer: null,
};
const customersReducer = (state = initialState, action) => {
    switch (action.type) {
        case types.CUSTOMERS_FETCH: {
            return Object.assign(Object.assign({}, state), { loaded: false, loading: true });
        }
        case types.CUSTOMERS_FETCH_SUCCESS: {
            return Object.assign(Object.assign({}, state), { customers: action.payload, total: action.total, loading: false, loaded: true });
        }
        case types.CUSTOMERS_FETCH_FAIL: {
            return Object.assign(Object.assign({}, state), { loading: false, loaded: true });
        }
        case types.CUSTOMER_SELECT: {
            return Object.assign(Object.assign({}, state), { selectedCustomer: action.payload });
        }
        case types.CUSTOMER_UPDATE: {
            const updatedCustomers = state.customers.map((c) => {
                if (c.code !== action.payload.code) {
                    return c;
                }
                return Object.assign(Object.assign({}, c), action.payload);
            });
            return Object.assign(Object.assign({}, state), { customers: updatedCustomers });
        }
        case clientTypes.CLIENT_SELECT: {
            return Object.assign(Object.assign({}, state), { selectedCustomer: null, loading: true, loaded: false });
        }
        default:
            return state;
    }
};
export default customersReducer;
